// extracted by mini-css-extract-plugin
export default {"listWrapper":"u6Gr7lfU","title":"nOwOjc79","card":"d2W4FO_9","cardTitle":"km4Cfiqr","cardSubtitle":"jCPXEYOF","cardDate":"KBfWjNJN"};